module.exports = __webpack_public_path__ + "media/images/pay1_color_mobile-4f08d890b9d9a79e3d921d643808cacc.svg";